<app-page-heading [heading]="heading" 
                  [hasBackButton]="true"
                  [backPageName]="backPageName"
                  [tabName]="'cases'">
</app-page-heading>

<app-banner *ngIf="!isAuthorised" [bannerText]="bannerText"></app-banner>


<div class="stepper-container">
  <mat-horizontal-stepper #stepper [linear]="true">
    <!---------------------------->
    <!-- STEP: Association:-->
    <!---------------------------->
    <mat-step #associationMatStep [completed]="associationFormGroup.valid">
      <ng-template matStepLabel>Association</ng-template>
      <app-case-association-step #associationStep
                                 [type]="caseType.Funeral"
                                 [data]="caseFuneralDTO"
                                 [formGroup]="associationFormGroup"
                                 [isEditMode]="isEditMode"
                                 (personId)="handleCommunicationNumberValue($event)"
                                 (updateHeading)="onUpdateHeadingChanged($event)"
                                 (updateForm)="onUpdateStepForm($event, formGroupName.AssociationFormGroup)">
      </app-case-association-step>
    </mat-step>
    
    <!---------------------------->
    <!--Detail Step-->
    <!---------------------------->
    
    <mat-step #detailStep [completed]="detailFormGroup.valid">
      <ng-template matStepLabel>Detail</ng-template>
      <form [formGroup]="detailFormGroup">
        <!-- Detail Step Row-1-->
        <mat-grid-list cols="2" rowHeight="75px">
          <!--Funeral Parlour-->
          <mat-grid-tile>
            <mat-slide-toggle formControlName="private" (change)="onDetailStepToggleValueChanged($event)">
              private
            </mat-slide-toggle>
            
            <ng-container *ngIf="!detailFormGroup.get('private').value else emptySpacer">
              <mat-form-field class="funeral-parlour">
                <mat-label>Funeral Parlour</mat-label>
                <input required matInput type="text"
                       [placeholder]="getInfoTooltip('Funeral Parlour')"
                       [formControl]="funeralParlourFormControl"
                       (input)="funeralParlourOrRepatriationProviderTextChanged$.next($any($event.target).value)"
                       (blur)="onBlurFuneralParlourOrRepatriationProviderSelected(providerDialogType.FuneralParlour)"
                       [matAutocomplete]="funeralParlourAuto">
                <mat-autocomplete #funeralParlourAuto="matAutocomplete" [panelWidth]="'40vw'">
                  <mat-option class="custom-mat-option"
                              *ngFor="let provider of filteredProvidersByType"
                              [value]="getProviderDisplayName(provider)"
                              (onSelectionChange)="onSelectionChange(provider, providerDialogType.FuneralParlour)">
                    {{getProviderDisplayName(provider)}}
                  </mat-option>
                </mat-autocomplete>
                <button *ngIf="funeralParlourFormControl.value" aria-label="Clear"
                        mat-button mat-icon-button matSuffix
                        (click)="clearFuneralParlourProvider();">
                  <mat-icon style="color: grey;">clear</mat-icon>
                </button>
              </mat-form-field>
              <mat-icon class="info-icon hand-cursor"
                        (click)="showSelectedProviderDialog(this.providerDialogType.FuneralParlour)">
                visibility
              </mat-icon>
              <mat-icon class="info-icon" [matTooltip]="getInfoTooltip('Funeral Parlour')">help_outline</mat-icon>
            </ng-container>
            <ng-template #emptySpacer>
              <div class="empty-space-width"><!--Empty Spacer to Retain Space--></div>
            </ng-template>
          </mat-grid-tile>
          
          <mat-grid-tile>
            <mat-form-field>
              <mat-label>Date of Death</mat-label>
              <input [formControl]="dateOfDeathFormControl" matInput required
                     [matDatepicker]="dateOfDeath">
              <mat-datepicker-toggle [for]="dateOfDeath" matIconSuffix>
              </mat-datepicker-toggle>
              <mat-datepicker #dateOfDeath></mat-datepicker>
            </mat-form-field>
            <mat-icon class="info-icon" [matTooltip]="getInfoTooltip('Date of Death')">
              help_outline
            </mat-icon>
          </mat-grid-tile>
        </mat-grid-list>
        
        <!-- Detail Step Row-2-->
        <mat-grid-list cols="2" rowHeight="75px">
          
          <!--Repatriation Service Provider-->
          <mat-grid-tile>
            <mat-form-field>
              <mat-label>Repatriation Service Provider</mat-label>
              <input matInput type="text"
                     [placeholder]="getInfoTooltip('Repatriation Service Provider')"
                     [formControl]="repatriationProviderFormControl"
                     (input)="funeralParlourOrRepatriationProviderTextChanged$.next($any($event.target).value)"
                     (blur)="onBlurFuneralParlourOrRepatriationProviderSelected(providerDialogType.RepatriationProvider)"
                     [matAutocomplete]="repatriationProviderAuto">
              <mat-autocomplete #repatriationProviderAuto="matAutocomplete" [panelWidth]="'40vw'">
                <mat-option class="custom-mat-option"
                            *ngFor="let provider of filteredProvidersByType"
                            [value]="getProviderDisplayName(provider)"
                            (onSelectionChange)="onSelectionChange(provider, providerDialogType.RepatriationProvider)">
                  {{getProviderDisplayName(provider)}}
                </mat-option>
              </mat-autocomplete>
              
              <button *ngIf="repatriationProviderFormControl.value" aria-label="Clear"
                      mat-button mat-icon-button matSuffix
                      (click)="clearRepatriationProvider();">
                <mat-icon style="color: grey;">clear</mat-icon>
              </button>
            </mat-form-field>
            
            <mat-icon class="info-icon hand-cursor"
                      (click)="showSelectedProviderDialog(this.providerDialogType.RepatriationProvider)">
              visibility
            </mat-icon>
            <mat-icon class="info-icon" [matTooltip]="getInfoTooltip('Repatriation Service Provider')">help_outline
            </mat-icon>
          </mat-grid-tile>
          
          <!--Location of Death-->
          <mat-grid-tile>
            <mat-form-field>
              <mat-label>Location of Death</mat-label>
              <input matInput required type="text"
                     [placeholder]="getInfoTooltip('Location of Death')"
                     [formControl]="deathLocationFormControl"
                     (input)="locationOfDeathTextChanged$.next($any($event.target).value)"
                     (blur)="onBlurLocationOfDeath()"
                     [matAutocomplete]="deathLocationFormControlAuto">
              <mat-autocomplete #deathLocationFormControlAuto="matAutocomplete" [panelWidth]="'40vw'">
                <mat-option (onSelectionChange)="onLocationOfDeathSelected($event.source.value)"
                            *ngFor="let location of filteredLocations"
                            [value]="getLocationDisplayString(location)"
                            class="custom-mat-option">
                  {{getLocationDisplayString(location)}}
                </mat-option>
              </mat-autocomplete>
              <button *ngIf="deathLocationFormControl.value" aria-label="Clear"
                      mat-button mat-icon-button matSuffix
                      (click)="clearLocationOfDeath()">
                <mat-icon style="color: grey;">clear</mat-icon>
              </button>
            </mat-form-field>
            <mat-icon class="info-icon" [matTooltip]="getInfoTooltip('Location of Death')">
              help_outline
            </mat-icon>
          </mat-grid-tile>
        
        </mat-grid-list>
        
        <!-- Detail Step Row-3-->
        <mat-grid-list cols="2" rowHeight="75px">
          
          <!--Hospital-->
          <mat-grid-tile>
            <mat-form-field>
              <mat-label>Hospital</mat-label>
              <input matInput type="text"
                     [placeholder]="getInfoTooltip('Hospital')"
                     [formControl]="hospitalFormControl"
                     (input)="hospitalOrMedicalPractitionerTextChanged$.next($any($event.target).value)"
                     (blur)="onBlurHospitalOrMedicalPractitionerProviderSelected(providerDialogType.Hospital)"
                     [matAutocomplete]="hospitalFormControlAuto">
              <mat-autocomplete #hospitalFormControlAuto="matAutocomplete" [panelWidth]="'40vw'">
                <mat-option class="custom-mat-option"
                            *ngFor="let provider of filteredProviders"
                            [value]="getProviderDisplayName(provider)"
                            (onSelectionChange)="onSelectionChange(provider, providerDialogType.Hospital)">
                  {{getProviderDisplayName(provider)}}
                </mat-option>
              </mat-autocomplete>
              <button *ngIf="hospitalFormControl.value" aria-label="Clear"
                      mat-button mat-icon-button matSuffix
                      (click)="clearHospitalProvider();">
                <mat-icon style="color: grey;">clear</mat-icon>
              </button>
            </mat-form-field>
            <mat-icon class="info-icon hand-cursor"
                      (click)="showSelectedProviderDialog(this.providerDialogType.Hospital)">
              visibility
            </mat-icon>
            <mat-icon class="info-icon" [matTooltip]="getInfoTooltip('Hospital')">help_outline</mat-icon>
          </mat-grid-tile>
          
          <!--DHA Bar code-->
          <mat-grid-tile>
            <mat-form-field>
              <mat-label>DHA Bar Code</mat-label>
              <input [formControl]="dhaBarCodeFormControl" type="text" matInput required>
            </mat-form-field>
            <mat-icon class="info-icon" [matTooltip]="getInfoTooltip('DHA Bar Code')">
              help_outline
            </mat-icon>
          </mat-grid-tile>
        </mat-grid-list>
        
        <!-- Detail Step Row-4-->
        <mat-grid-list cols="2" rowHeight="75px">
          
          <!--Radio Button-->
          <mat-grid-tile>
            <mat-radio-group [formControlName]="controls.MedicalPractitionerOrTraditionalRadio" class="m-l-5"
                             [name]="detailStepRadioGroupName.MedicalPractitionerTraditionalLeaderRadioGroup"
                             (change)="onDetailStepRadioValueChanged($event)">
              <mat-radio-button class="m-r-5" [value]="detailStepType.MedicalPractitioner">
                Medical Practitioner
              </mat-radio-button>
              <mat-radio-button class="m-r-5" [value]="detailStepType.TraditionalLeader">
                Traditional Leader
              </mat-radio-button>
            </mat-radio-group>
          </mat-grid-tile>
          
          <!--Date of Death Certificate-->
          <mat-grid-tile>
            <mat-form-field>
              <mat-label [ngClass]="{'required': isDocumentationDateRequired}">
                Date of Death Certificate
              </mat-label>
              <input [formControl]="deathCertificateDateFormControl" matInput [required]=false
                     [matDatepicker]="deathCertificateDate">
              <mat-datepicker-toggle [for]="deathCertificateDate" matIconSuffix>
              </mat-datepicker-toggle>
              <mat-datepicker #deathCertificateDate></mat-datepicker>
            </mat-form-field>
            <mat-icon class="info-icon" [matTooltip]="getInfoTooltip('Death Certificate Date')">
              help_outline
            </mat-icon>
          </mat-grid-tile>
  
        
        </mat-grid-list>
        
        
        <mat-grid-list cols="2" rowHeight="75px">
          
          <ng-container *ngIf="isMedicalPractitioner">
            <!--Medical Practitioner-->
            <mat-grid-tile>
              <mat-form-field>
                <mat-label>Medical Practitioner</mat-label>
                <input matInput type="text"
                       required
                       [placeholder]="getInfoTooltip('Medical Practitioner')"
                       [formControl]="medicalPractitionerFormControl"
                       (input)="hospitalOrMedicalPractitionerTextChanged$.next($any($event.target).value)"
                       (blur)="onBlurHospitalOrMedicalPractitionerProviderSelected(providerDialogType.MedicalPractitioner)"
                       [matAutocomplete]="medicalPractitionerFormControlAuto">
                
                <mat-autocomplete #medicalPractitionerFormControlAuto="matAutocomplete" [panelWidth]="'40vw'">
                  <mat-option class="custom-mat-option"
                              *ngFor="let provider of filteredProviders"
                              [value]="getProviderDisplayName(provider)"
                              (onSelectionChange)="onSelectionChange(provider, providerDialogType.MedicalPractitioner)">
                    {{getProviderDisplayName(provider)}}
                  </mat-option>
                </mat-autocomplete>
                
                <button *ngIf="medicalPractitionerFormControl.value" aria-label="Clear"
                        mat-button mat-icon-button matSuffix
                        (click)="clearMedicalPractitionerProvider();">
                  <mat-icon style="color: grey;">clear</mat-icon>
                </button>
              </mat-form-field>
              <mat-icon class="info-icon hand-cursor"
                        (click)="showSelectedProviderDialog(this.providerDialogType.MedicalPractitioner)">
                visibility
              </mat-icon>
              <mat-icon class="info-icon" [matTooltip]="getInfoTooltip('Medical Practitioner')">help_outline
              </mat-icon>
            </mat-grid-tile>
          </ng-container>
          
          <ng-container *ngIf="isTraditionalLeader">
            <!--Traditional Leader Name-->
            <mat-grid-tile>
              <mat-form-field>
                <mat-label>Traditional Leader Name</mat-label>
                <input [formControl]="traditionalLeaderNameFormControl" type="text" matInput required>
              </mat-form-field>
              <mat-icon class="info-icon" [matTooltip]="getInfoTooltip('Traditional Leader Name')">
                help_outline
              </mat-icon>
            </mat-grid-tile>
          </ng-container>
          
          <!--Certifier of Death Certificate-->
          <mat-grid-tile>
            <mat-form-field>
              <mat-label>Certifier of Death Certificate</mat-label>
              <input [formControl]="deathCertifierFormControl" type="text" matInput>
            </mat-form-field>
            <mat-icon class="info-icon" [matTooltip]="getInfoTooltip('Death Certifier')">
              help_outline
            </mat-icon>
          </mat-grid-tile>
        
        </mat-grid-list>
        
        <!-- Detail Step Row-7-->
        <mat-grid-list cols="2" rowHeight="75px">
          
          <ng-container *ngIf="isMedicalPractitioner">
            <mat-grid-tile>&nbsp;</mat-grid-tile>
          </ng-container>
          
          <!--Traditional Leader Contact Number-->
          <mat-grid-tile *ngIf="isTraditionalLeader">
            <mat-form-field>
              <mat-label>Traditional Leader Contact Number</mat-label>
              <input [formControl]="traditionalLeaderContactNumberFormControl" type="text" matInput required>
              
              <mat-error *ngIf="detailFormGroup.controls[controls.TraditionalLeaderContactNumber].touched &&
                                detailFormGroup.controls[controls.TraditionalLeaderContactNumber].invalid">
                <ng-container *ngIf="detailFormGroup.controls[controls.TraditionalLeaderContactNumber]?.errors?.minlength ||
                                     detailFormGroup.controls[controls.TraditionalLeaderContactNumber]?.errors?.maxlength  ||
                                     detailFormGroup.controls[controls.TraditionalLeaderContactNumber]?.errors?.invalidNumber">
                  Please enter 10 digits only
                </ng-container>
              </mat-error>
            
            </mat-form-field>
            <mat-icon class="info-icon" [matTooltip]="getInfoTooltip('Traditional Leader Contact Number')">
              help_outline
            </mat-icon>
          </mat-grid-tile>
          
          
          <!--Communication Number-->
          <mat-grid-tile>
            <mat-form-field>
              <mat-label>Communication Number</mat-label>
              <input [formControlName]="'communicationNumber'" type="text" matInput required>
              
              <mat-error *ngIf="communicationNumberAbstractControl && communicationNumberAbstractControl.invalid">
                <span *ngIf="communicationNumberAbstractControl.errors?.invalidMobileNumber">
                  Invalid mobile number.
                </span>
              </mat-error>
            
            </mat-form-field>
            <mat-icon class="info-icon" [matTooltip]="getInfoTooltip('Communication Number')">
              help_outline
            </mat-icon>
          </mat-grid-tile>
        
        </mat-grid-list>
        
        <div class="button-container">
          <button mat-raised-button matStepperPrevious color="primary">Back</button>
          <button mat-raised-button color="warn" (click)="resetDetailFormGroup();">Clear</button>
          <button mat-raised-button matStepperNext color="primary">Next</button>
        </div>
      </form>
    </mat-step>
    
    <!---------------------------->
    <!--Documentation Step-->
    <!---------------------------->
    
    <mat-step #documentationStep [completed]="documentationFormGroup.valid">
      <ng-template matStepLabel>Documentation</ng-template>
      <form [formGroup]="documentationFormGroup" id="documentationForm">
        
        <ng-container *ngFor="let item of fileUploadConfig">
          <ng-container [ngTemplateOutlet]="fileUploadTemplate"
                        [ngTemplateOutletContext]="{
                        label: item.label,
                        config:  item,
                        configName: item.name,
                        isRequired: item.isRequired,
                        formControlName: item.formControlName,
                        formControlInstance:  item.formControlInstance
                        }">
          </ng-container>
        </ng-container>
        
        
        <div class="clearfix">
          <div class="flex flex-wrap">
            <div class="col-4">
              <mat-icon class="info-icon" [matTooltip]="getInfoTooltip('Documentation Completion Date')">
                help_outline
              </mat-icon>
              <mat-form-field>
                <mat-label [ngClass]="{'required': isDocumentationDateRequired}">
                  Documentation Completion Date
                </mat-label>
                <input [formControl]="documentationCompleteDateFormControl" matInput [required]=false
                       [matDatepicker]="documentationCompleteDate">
                <mat-datepicker-toggle [for]="documentationCompleteDate" matIconSuffix>
                </mat-datepicker-toggle>
                <mat-datepicker #documentationCompleteDate></mat-datepicker>
              </mat-form-field>
            </div>
          </div>
        </div>
        <div class="button-container">
          <button mat-raised-button matStepperPrevious color="primary">Back</button>
          <button mat-raised-button matStepperNext color="primary">Next</button>
        </div>
      </form>
    </mat-step>
    
    
    <!---------------------------->
    <!-- STEP: Transaction:-->
    <!---------------------------->
    
    <mat-step *ngIf="isEditMode" [completed]="transactionFormGroup.valid"
              #transactionMatStep>
      <ng-template matStepLabel>Transactions</ng-template>
      <app-case-transaction-step #transactionStep
                                 [data]="caseFuneralDTO"
                                 [formGroup]="transactionFormGroup"
                                 [isEditMode]="isEditMode">
      </app-case-transaction-step>
    </mat-step>
    
    
    <!---------------------------->
    <!-- STEP: Payments:-->
    <!---------------------------->
    
    <mat-step *ngIf="isEditMode" [completed]="paymentFormGroup.valid"
              #paymentMatStep>
      <ng-template matStepLabel>Payments</ng-template>
      <app-case-payments-step #paymentStep>
        <app-payments [paymentsByCaseId]="caseId"></app-payments>
      </app-case-payments-step>
    </mat-step>
    
    <!---------------------------->
    <!-- STEP: Issues:-->
    <!---------------------------->
    <mat-step #issuesMatStep [completed]="issueTicketFormGroup.valid">
      <ng-template matStepLabel>Issues</ng-template>
      <app-case-issues-step #issueStep
                            [type]="caseType.Funeral"
                            [caseId]="caseId"
                            [data]="caseFuneralDTO"
                            [formGroup]="issueTicketFormGroup"
                            [isEditMode]="isEditMode">
      </app-case-issues-step>
    </mat-step>
    
    <!---------------------------->
    <!-- STEP: Status:-->
    <!---------------------------->
    
    <mat-step #statusMatStep [completed]="statusFormGroup.valid">
      <ng-template matStepLabel>Status</ng-template>
      <app-case-status-step #statusStep
                            [isEditMode]="isEditMode"
                            [type]="caseType.Funeral"
                            [data]="caseFuneralDTO"
                            [formGroup]="statusFormGroup"
                            (onSave)="saveCaseFuneralDTO()">
      </app-case-status-step>
    </mat-step>
    
    <!---------------------------->
    <!-- STEP <HERE>:-->
    <!---------------------------->
  
  </mat-horizontal-stepper>
  
  <ng-template #noFileChoose>
    No File Chosen
  </ng-template>
</div>


<!--Empty Placeholder-->
<ng-template #showEmptySpacer>
  <!--Empty Spacer-->
  <mat-grid-tile>&nbsp;</mat-grid-tile>
</ng-template>

<!---------------------------->
<!--Documentation Step-->
<!--File Upload Template-->
<!---------------------------->
<ng-template #fileUploadTemplate
             let-label="label"
             let-config="config"
             let-configName="configName"
             let-isRequired="isRequired"
             let-formControlName="formControlName"
             let-formControlInstance="formControlInstance">
  
  
  <div class="flex flex-wrap m-t-15">
    <div class="col-4">
      <mat-icon class="info-icon documentation-help-icon" [matTooltip]="getInfoTooltip(label)">
        help_outline
      </mat-icon>
      
      <!---------------------------------------------------------->
      <!--SHOW VISUALLY "*" BUT IT NOT ACTUALLY REQUIRED-->
      <!---------------------------------------------------------->
      <ng-container *ngIf="isRequired else showLabel">
        <mat-label [ngClass]="{'required': !documentationFormGroup.controls[formControlName].value}">
          {{label}}
        </mat-label>
        <span color="warn"
              *ngIf="documentationFormGroup.controls[formControlName]?.errors?.required">*</span>
      </ng-container>
      
      <ng-template #showLabel>
        {{label}}
      </ng-template>
    </div>
    <div class="col-2">
      <app-file-upload [config]="config"
                       (onUploadSuccess)="onFileUploadSuccess($event);">
      </app-file-upload>
    </div>
    <div class="col-6">
      <div class="flex flex-wrap">
        <div class="col-8">
          <ng-container *ngIf="config?.uploadedFileData?.fileId else noFileChoose">
            <a target="#" (click)="downloadFile($event, configName)" href="#">
              {{config?.uploadedFileData?.name}}{{config?.uploadedFileData?.extension}}
            </a>
          </ng-container>
        
        </div>
        <div class="col-2">
          <ng-container
            *ngIf="config?.uploadedFileData?.created else fileUpdatedAt">
            {{config?.uploadedFileData?.created | date: dateFormat}}
          </ng-container>
          <ng-template #fileUpdatedAt>
            {{config?.uploadedFileData?.updated | date: dateFormat}}
          </ng-template>
        </div>
        <div class="col-2">
          <div *ngIf="formControlInstance.value" class=" table-icon">
            <mat-icon class="mat-primary-color hand-cursor" matTooltip="DELETE"
                      (click)="deleteFile(formControlInstance.value,configName)">
              delete
            </mat-icon>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>
